import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormField } from "@/components/ui/FormField";
import { Button } from "@/components/ui/Button";
import { supabase } from "@/lib/supabase";

export function ResetPasswordPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (password !== confirmPassword) {
      setError(t("auth.passwordMismatch"));
      return;
    }

    setLoading(true);
    try {
      const { error: updateError } = await supabase.auth.updateUser({ password });
      if (updateError) {
        setError(updateError.message);
      } else {
        setSuccess(true);
        setTimeout(() => navigate("/login", { replace: true }), 2000);
      }
    } catch {
      setError(t("auth.resetError"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col gap-4"
    >
      <FormField
        label={t("auth.newPassword")}
        value={password}
        onChange={setPassword}
        type="password"
        autoComplete="new-password"
      />
      <FormField
        label={t("auth.confirmPassword")}
        value={confirmPassword}
        onChange={setConfirmPassword}
        type="password"
        autoComplete="new-password"
      />

      {success && (
        <p className="text-sm text-green-600">{t("auth.passwordUpdated")}</p>
      )}
      {error && (
        <p className="text-sm text-red-500">{error}</p>
      )}

      <Button variant="auth" type="submit" disabled={loading || success}>
        {loading ? t("common.loading") : t("auth.resetPassword")}
      </Button>
      <div className="text-center">
        <Link
          to="/login"
          className="text-xs text-text-muted hover:text-accent"
        >
          {t("auth.backToLogin")}
        </Link>
      </div>
    </form>
  );
}
